import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ProgressSpinnerModule } from '@openng/optimus-ui/progressspinner';

@Component({
  selector: 'ui-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  imports: [ProgressSpinnerModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [],
})
export class LoadingOverlayComponent {}
